import request from '@/utils/request'
import { urlEncode } from '@/utils/urls'
import md5 from 'md5'

// 个人用户API类
class PersonalAPI {
  // 登录
  static signIn (data) {
    const loginData = {
      ...data,
      password: md5(data.password), // 使用MD5加密密码
      loginType: 'YQ_personalManage_LOGIN',
      appKey: 'YQ'
    }

    return request({
      url: '/api/v4/users/login',
      method: 'POST',
      data: loginData

    })
  }
}

/**
 * 个人登录 - 兼容现有调用方式
 */
export const personalLogin = (data) => {
  return PersonalAPI.signIn(data)
}

// 导出API类
export { PersonalAPI }

export const getPersonals = (reqPersonals) => {
  return request({
    url: '/acl/api/v1/personals?' + urlEncode(reqPersonals),
    method: 'GET'
  })
}

export const createPersonal = (reqParam) => {
  return request({
    url: '/acl/api/v1/personals',
    method: 'POST',
    data: reqParam
  })
}

export const completeInterview = (reqParam) => {
  return request({
    url: '/api/v1/personals/interview/complete',
    method: 'POST',
    data: reqParam
  })
}
